import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import FiltertRightbar from "./FiltersRightbar";
import "./Quotation.scss";
import AllPurchaseOrder from "./AllPurchaseOrder";
import {
  getPurchaseOrderList,
  SetParams,
  FilterClear,
  FiltersShowRightSidebar,
} from "../../store/PurchaseOrder/actions";

import LoadingModel from "../LoadingModel";
import TimeLineLogRightbar from "./TimeLineLogRightbar";

class PurchaseOrderDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { FilterToggle: false };
  }
  componentDidMount() {
    this.props.FilterClear();

    this.props.getPurchaseOrderList({
      ...this.props.params,
      // pistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      poitems__product: "",
    });
    // this.props.listlayout("list");
    this.props.SetParams({
      ...this.props.params,
      // mrstatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      poitems__product: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Purchase Order Dashboard
                    </h5>
                    <div className="float-right">
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar()}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <AllPurchaseOrder />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
            <TimeLineLogRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { QRowList, QRowListCount, params, loading } = state.PurchaseOrder;
  return {
    QRowList,
    QRowListCount,
    params,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getPurchaseOrderList,
  SetParams,
  FilterClear,
  FiltersShowRightSidebar,
})(PurchaseOrderDashboard);
